// Global Instructions Rule Applied!

import { FundState, FundsAction } from '../../interfaces/funds.ts'
import { FundRecordFields } from '../../data_models/fund_record.ts'
import {
  SET_FILTER_OPTIONS,
  SET_FUNDS,
  SET_ACTIVE_FILTERS,
  SET_ACTIVE_SORTING,
  CLEAR_ACTIVE_FILTERS,
  CLEAR_ACTIVE_SORTING,
  UPDATE_FUND_RECORD,
  ADD_FUND,
  APPEND_FUNDS
} from './constants.ts'
import { UPDATE_RECORD_BY_SEARCH } from '../../sync_engine/constants.ts'

const fundsReducer = (
  state: FundState = {
    filterOptions: { data: {} },
    activeFilters: [],
    activeSorting: [],
    data: [],
    hasMore: false,
    currentPage: 1
  },
  action: FundsAction | { type: typeof UPDATE_RECORD_BY_SEARCH; payload: any }
): FundState => {
  switch (action.type) {
    case SET_FILTER_OPTIONS: {
      const { response } = (action as { payload: { response: any } }).payload
      return { ...state, filterOptions: response }
    }

    case SET_FUNDS: {
      const { response } = (action as { payload: { response: { data: any[]; hasMore: boolean } } }).payload
      return {
        ...state,
        data: response.data,
        hasMore: response.hasMore,
        currentPage: 1
      }
    }

    case APPEND_FUNDS: {
      const { response } = (action as { payload: { response: { data: any[]; hasMore: boolean } } }).payload
      return {
        ...state,
        data: [...state.data, ...response.data],
        hasMore: response.hasMore,
        currentPage: state.currentPage + 1
      }
    }

    case SET_ACTIVE_FILTERS: {
      const { filters } = (action as { payload: { filters: any[] } }).payload
      return { ...state, activeFilters: filters }
    }

    case SET_ACTIVE_SORTING: {
      const { sorting } = (action as { payload: { sorting: any[] } }).payload
      return { ...state, activeSorting: sorting }
    }

    case CLEAR_ACTIVE_FILTERS: {
      return { ...state, activeFilters: [] }
    }

    case CLEAR_ACTIVE_SORTING: {
      return { ...state, activeSorting: [] }
    }

    case UPDATE_FUND_RECORD: {
      const { fundId, updates } = (action as { payload: { fundId: string; updates: Record<string, any> } }).payload
      const idKey = FundRecordFields.funds__id
      const fundExists = state.data.some((fund) => (fund as any)[idKey] === fundId)
      if (!fundExists) return state

      const updatesIdField = updates[idKey] || updates.id
      const updateFieldCount = Object.keys(updates).length
      const isFullRecordRefresh =
        (updatesIdField === fundId || updatesIdField === String(fundId)) && updateFieldCount > 5

      return {
        ...state,
        data: state.data.map((fund) => {
          if ((fund as any)[idKey] === fundId) {
            return isFullRecordRefresh ? (updates as any) : { ...fund, ...updates }
          }
          return fund
        })
      }
    }

    case ADD_FUND: {
      const { fund } = (action as { payload: { fund: any } }).payload
      return { ...state, data: [fund, ...state.data] }
    }

    case UPDATE_RECORD_BY_SEARCH: {
      const { searchField, searchValue, updates } = (action as { payload: any }).payload
      return {
        ...state,
        data: state.data.map((record) => {
          const recordValue = (record as any)[searchField]
          const matches =
            recordValue === searchValue ||
            String(recordValue) === String(searchValue) ||
            recordValue == searchValue

          if (matches) {
            const filteredUpdates = Object.keys(updates).reduce(
              (acc, key) => {
                if (key in (record as any)) acc[key] = updates[key]
                return acc
              },
              {} as Record<string, any>
            )
            if (Object.keys(filteredUpdates).length > 0) {
              return { ...record, ...filteredUpdates }
            }
          }
          return record
        })
      }
    }

    default:
      return state
  }
}

export default fundsReducer
export * from './fund_actions.ts'
export * from './selectors.ts'
